import { Routes } from '@angular/router'
import { UserInfoResolver } from './core/services/user-info.resolver'
import { AuthGuard } from './core/auth/auth.guard'
import { RoleGuard } from './core/auth/role.guard'
import { AlreadyLoggedInGuard } from './core/auth/already-logged-in.guard'
import { Roles } from './core/auth/role'
import { PrivateLayoutComponent } from './layouts/private-layout/private-layout.component'
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component'
import { Error404Component } from './views/auth/page-not-found/error-404/error-404.component'
import { AccessDeniedComponent } from './views/auth/access-denied/access-denied.component'

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth/sign-in',
    pathMatch: 'full',
  },
  {
    path: 'system-admin',
    component: PrivateLayoutComponent,
    resolve: { userInfo: UserInfoResolver },
    canActivate: [AuthGuard, RoleGuard],
    data: { preload: true, delay: 3000, roles: [Roles.SYSTEM_ADMIN] },
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./views/system-admin/system-admin.route').then(
            (mod) => mod.SYSTEM_ADMIN_ROUTES
          ),
        data: { preload: true, delay: 3000, roles: [Roles.SYSTEM_ADMIN] },
      },
    ],
  },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    canActivate: [AlreadyLoggedInGuard],
    loadChildren: () =>
      import('./views/auth/auth.route').then((mod) => mod.AUTH_ROUTES),
    data: { preload: true },
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
    data: { title: 'Access Denied' },
  },
  {
    path: '**',
    component: Error404Component,
    pathMatch: 'full',
  },
]
